import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';
import { SkyClubEntity } from '../../models/sky-club.entities';
import * as APIActions from '../actions/api.actions';
import * as AEMActions from '../actions/content.actions';

export const SKYCLUB_FEATURE_KEY = 'skyClub';

export interface State extends EntityState<SkyClubEntity> {
  selectedId?: string | number; // which SkyClub record has been selected
  loaded: boolean; // has the SkyClub list been loaded
  error?: string | null; // last known error (if any)
}

export const skyClubAdapter: EntityAdapter<SkyClubEntity> =
  createEntityAdapter<SkyClubEntity>();

export const initialState: State = skyClubAdapter.getInitialState({
  loaded: false
});

const skyClubReducer = createReducer(
  initialState,
  on(AEMActions.loadAEMContentSuccess, (state, { aemContent }) =>
    skyClubAdapter.setOne(aemContent, { ...state, loaded: true })
  ),
  on(AEMActions.loadAEMContentFailure, (state, { aemContentError }) =>
    skyClubAdapter.setOne(aemContentError, { ...state, loaded: false })
  ),
  on(APIActions.loadPurchaseContentSuccess, (state, { data }) =>
    skyClubAdapter.setOne(data, { ...state, loaded: true })
  ),
  on(APIActions.loadPurchaseContentFail, (state, { error }) =>
    skyClubAdapter.setOne(error, { ...state, loaded: true })
  ),
  on(APIActions.loadAddToCartSuccess, (state, { data }) =>
    skyClubAdapter.setOne(data, { ...state, loaded: true })
  ),
  on(APIActions.loadAddToCartFail, (state, { error }) =>
    skyClubAdapter.setOne(error, { ...state, loaded: true })
  )
);

export const reducer = (state: State | undefined, action: Action) =>
  skyClubReducer(state, action);
